<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells v-if="is_show_create_staff_button || is_transfer_department">
        <template v-if="is_show_create_staff_button">
          <app-button @click.native="$modal.show('create-staff-modal')" size="small">
            Staff transfer
          </app-button>
        </template>
        <template v-if="is_general_manager || is_transfer_department">
          <app-button @click.native="onShowHotelArrivalPopup" size="small">
            Hotel Arrival
          </app-button>
          <app-button @click.native="onShowHotelDeparturePopup" size="small" theme="warn">
            Hotel Departure
          </app-button>
          <app-button @click.native="onShowHotelOtherPopup" size="small" theme="info">
            Hotel Other
          </app-button>
        </template>
      </app-cells>
      <template v-if="arranged_transfers.length">
        <app-cells>
          <h2 class="title">Waiting driver approval</h2>
        </app-cells>
        <div v-for="transfer_item in arranged_transfers" :key="`waiting_${transfer_item.name}`" style="margin-bottom: 30px">
          <app-cells v-if="transfer_item.name">
            <h2 class="title">{{ transfer_item.name }}</h2>
            <div v-if="transfer_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
          </app-cells>
          <div class="transfer-list">
            <transfers-blocks
              v-for="(transfer, index) in transfer_item.items"
              :key="`waiting_${transfer.id}`"
              @onArrangePopupOpen="onArrangePopupOpen"
              @onOpenEditPopup="onOpenEditPopup"
              @onCancelledTransfer="onCancelledTransfer"
              @onDeleteTransfer="onDeleteTransfer"
              :transfer="transfer"
              :count="index + 1"
              :lazy_details="true"
              :is_show_edit_cancel_buttons="transfer.type.code === 'staff'"
            />
          </div>
        </div>
      </template>
      <template v-if="need_transfers.length">
        <app-cells>
          <h2 class="title">Need amendment</h2>
        </app-cells>
        <div v-for="transfer_item in need_transfers" :key="`need_${transfer_item.name}`" style="margin-bottom: 30px">
          <app-cells v-if="transfer_item.name">
            <h2 class="title">{{ transfer_item.name }}</h2>
            <div v-if="transfer_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
          </app-cells>
          <div class="transfer-list">
            <transfers-blocks
              v-for="(transfer, index) in transfer_item.items"
              :key="`need_${transfer.id}`"
              @onArrangePopupOpen="onArrangePopupOpen"
              @onOpenEditPopup="onOpenEditPopup"
              @onCancelledTransfer="onCancelledTransfer"
              @onDeleteTransfer="onDeleteTransfer"
              :transfer="transfer"
              :count="index + 1"
              :lazy_details="true"
              :is_show_edit_cancel_buttons="transfer.type.code === 'staff'"
            />
          </div>
        </div>
      </template>
      <app-cells>
        <app-date-picker
          @input="onFiltersChange"
          v-model="filter_date"
          placeholder="Pick-up date"
          class="datepicker--220"
        />
        <app-input
          @input.native="onTransferSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by group name"
          name="search"
        />
        <app-select
          @input="onFiltersChange"
          v-model="filter_car"
          :reduce="item => item.id"
          :options="cars_options"
          :display-field="option => `${option.car_model.name} ${option.plate_number ? `(${option.plate_number})` : ''}`"
          label="plate_number"
          placeholder="Select car"
          class="select--300"
        />
        <app-select
          @input="onFiltersChange"
          v-model="filter_driver"
          :reduce="item => item.id"
          :options="drivers_options"
          label="full_name"
          placeholder="Enter driver"
          class="select--300"
        />
        <app-filters
          v-model="filter"
          :filters="filters"
          name="filterTransfers"
          @change="onChangeFilter"
        />
      </app-cells>
      <template v-if="requested_transfers.length">
        <div v-for="transfer_item in requested_transfers" :key="`active_${transfer_item.name}`" style="margin-bottom: 30px">
          <app-cells v-if="transfer_item.name" class="sticky-title">
            <h2 class="title">{{ transfer_item.name }}</h2>
            <div v-if="transfer_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
          </app-cells>
          <div class="transfer-list">
            <transfers-blocks
              v-for="(transfer, index) in transfer_item.items"
              :key="`requested_${transfer.id}`"
              @onArrangePopupOpen="onArrangePopupOpen"
              @onOpenEditPopup="onOpenEditPopup"
              @onCancelledTransfer="onCancelledTransfer"
              @onDeleteTransfer="onDeleteTransfer"
              :transfer="transfer"
              :count="index + 1"
              :lazy_details="true"
              :is_show_edit_cancel_buttons="transfer.type.code === 'staff' || transfer.type.code === 'hotel_arrival' || transfer.type.code === 'hotel_departure' || transfer.type.code === 'hotel_other'"
            />
          </div>
        </div>
        <app-cells position="between">
          <div>
            <paginate
                :clickHandler="onClickPagination"
                v-if="pagination_requested.pages > 1"
                v-model="pagination_requested.page"
                :page-count="pagination_requested.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_requested.count" :count="table_requested_length" :page="pagination_requested.page" :limit="60" />
        </app-cells>
      </template>
      <div v-else class="no-results">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no transfers yet</div>
      </div>
    </template>
    <modal
        name="arrange-popup"
        :width="1400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('arrange-popup')" class="popup__close" type="button"></button>
        <div class="popup__title">Arrange transfer</div>
        <div v-if="transfer" class="popup__body">
          <form @submit.prevent="onCheckArrangeForm">
            <div class="arrange-popup">
              <app-grid>
                <template #item-1>
                  <div class="arrange-popup__name">{{ transfer.name }} - {{ transfer.pax }} Pax</div>
                  <div v-if="transfer.status.code === 'need_amended'" class="arrange-popup__before">
                    <div class="before-info">
                      <div class="before-info__title">Before changes:</div>
                      <div class="before-info__wrapper">
                        <div v-if="transfer.amended_data.pax" class="before-info__row">
                          <span>Pax:</span>
                          <span>{{ transfer.amended_data.pax }}</span>
                        </div>
                        <div v-if="transfer.amended_data.pick_up_date" class="before-info__row">
                          <span>Pick-up date:</span>
                          <span>{{ dateFormat(transfer.amended_data.pick_up_date) }}</span>
                        </div>
                        <div v-if="transfer.amended_data.pick_up_time" class="before-info__row">
                          <span>Pick-up time:</span>
                          <span>{{ transfer.amended_data.pick_up_time }}</span>
                        </div>
                      </div>
                      <div v-if="transfer.amended_data.pick_up_point" class="before-info__row">
                        <span>Pick-up point:</span>
                        <span>{{ transfer.pick_up_point.short_name }}</span>
                      </div>
                      <div class="before-info__row">
                        <span>Points:</span>
                        <span class="before-info__points">
                          <span v-for="(point, index) in transfer.amended_data.points" :key="point.id" class="before-info__point">
                            {{ point.location }}
                            <img v-if="index !== transfer.amended_data.points.length - 1" src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="arrange-popup__points">
                    {{ transfer.pick_up_point.short_name }}
                    <img src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                    <span v-for="(point, index) in transfer.points" :key="point.id" class="arrange-popup__point">
                      {{ point.location.short_name }}
                      <img v-if="index !== transfer.points.length - 1" src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                    </span>
                  </div>
                  <div v-if="['arrival', 'departure', 'climbing', 'day_trip', 'safari'].includes(transfer.type.code)" class="arrange-popup__info">
                    <template v-if="transfer.type.code === 'arrival'">
                      <div class="arrival-popup__row">
                        <span>Pick-up date:</span>
                        <span>
                          {{ dateFormat(transfer.pick_up_date) }}<i class="arrival-popup__divider">|</i>{{ transfer.pick_up_time }}
                        </span>
                      </div>
                      <div class="arrival-popup__row">
                        <span>Pick-up point:</span>
                        <span>{{ transfer.pick_up_point.short_name }}</span>
                      </div>
                    </template>
                    <template v-if="transfer.type.code === 'arrival' || transfer.type.code === 'departure'">
                      <div class="arrange-popup__row">
                        <span>Transport details:</span>
                        <span>{{ transfer.transport_method.name }}<i class="arrange-popup__divider">|</i>{{ transfer.transport_company ? transfer.transport_company.name : '' }}<i v-if="transfer.transport_company" class="arrange-popup__divider">|</i>{{ transfer.transport_flight_number || '' }}<i v-if="transfer.transport_flight_number" class="arrange-popup__divider">|</i>{{ dateFormat(transfer.transport_date) }}<i v-if="transfer.transport_time" class="arrange-popup__divider">|</i>{{ transfer.transport_time }}</span>
                      </div>
                    </template>
                    <template v-if="transfer.type.code === 'climbing'">
                      <div class="arrange-popup__row">
                        <span>Climbing group:</span>
                        <router-link :to="{ name: 'climbing-groups-detail', params: { id: transfer.climbing_group.id } }" class="arrange-popup__link-bordered">{{ transfer.climbing_group.name }}</router-link>
                      </div>
                      <div v-if="transfer.climbing_group && transfer.climbing_group.meeting_time" class="arrange-popup__row">
                        <span>Meeting time:</span>
                        <span>{{ transfer.climbing_group.meeting_time }}</span>
                      </div>
                      <div v-if="transfer.climbing_group.starting_point && transfer.climbing_group.starting_point" class="arrange-popup__row">
                        <span>Starting point:</span>
                        <span>{{ transfer.climbing_group.starting_point.short_name }}</span>
                      </div>
                    </template>
                    <template v-if="transfer.type.code === 'day_trip'">
                      <div class="arrange-popup__row">
                        <span>Day trip group:</span>
                        <router-link :to="{ name: 'day-trips-groups-detail', params: { id: transfer.day_trip.id } }" class="arrange-popup__link-bordered">{{ transfer.day_trip.name }}</router-link>
                      </div>
                    </template>
                    <template v-if="transfer.type.code === 'safari'">
                      <div class="arrange-popup__row">
                        <span>Safari group:</span>
                        <router-link :to="{ name: 'safari-groups-detail', params: { id: transfer.safari_group.id } }" class="arrange-popup__link-bordered">{{ transfer.safari_group.name }}</router-link>
                      </div>
                    </template>
                  </div>
                  <div class="arrange-popup__row arrange-popup__row--4">
                    <app-form-group v-if="transfer.type.code !== 'arrival'" label="Pick-up date" class="form-group--no-indent" required>
                      <app-date-picker
                        v-model="transfer.pick_up_date"
                        placeholder="Tour start"
                        :clearable="false"
                        :error="$v.transfer.pick_up_date.$error"
                      />
                      <template #error>
                        <div v-if="$v.transfer.pick_up_date.$dirty && !$v.transfer.pick_up_date.required">Required field</div>
                        <div v-if="$v.transfer.pick_up_date.$dirty && !$v.transfer.pick_up_date.minValue">
                          Date cannot be less than the current date
                        </div>
                      </template>
                    </app-form-group>
                    <app-form-group v-if="transfer.type.code !== 'arrival'" label="Pick-up time" label-for="reported_time" class="form-group--no-indent" required>
                      <app-input
                          v-model="transfer.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="00:00"
                          autocomplete="off"
                          id="reported_time"
                          name="reported_time"
                          @paste.native.prevent
                          :error="$v.transfer.pick_up_time.$error"
                      />
                      <template #error>
                        <div v-if="$v.transfer.pick_up_time.$dirty && !$v.transfer.pick_up_time.required">Required field</div>
                        <div v-if="$v.transfer.pick_up_time.$dirty && !$v.transfer.pick_up_time.timeRegex">Wrong time</div>
                      </template>
                    </app-form-group>
                    <app-form-group label="Start date" class="form-group--no-indent" required>
                      <app-date-picker
                        v-model="transfer.start_date"
                        placeholder="Start date"
                        :clearable="false"
                        :error="$v.transfer.start_date.$error"
                      />
                      <template #error>
                        <div v-if="$v.transfer.start_date.$dirty && !$v.transfer.start_date.required">Required field</div>
                        <div v-if="$v.transfer.start_date.$dirty && !$v.transfer.start_date.minValue">
                          Date cannot be less than the current date
                        </div>
                      </template>
                    </app-form-group>
                    <app-form-group label="Start time" label-for="reported_time" class="form-group--no-indent" required>
                      <app-input
                          v-model="transfer.start_time"
                          v-mask="'99:99'"
                          placeholder="00:00"
                          autocomplete="off"
                          id="reported_time"
                          name="reported_time"
                          @paste.native.prevent
                          :error="$v.transfer.start_time.$error"
                      />
                      <template #error>
                        <div v-if="$v.transfer.start_time.$dirty && !$v.transfer.start_time.required">Required field</div>
                        <div v-if="$v.transfer.start_time.$dirty && !$v.transfer.start_time.timeRegex">Wrong time</div>
                      </template>
                    </app-form-group>
                  </div>
                  <div class="arrange-popup__row arrange-popup__row--2">
                    <app-form-group label="Finish date" class="form-group--no-indent" required>
                      <app-date-picker
                        v-model="transfer.estimated_finish_date"
                        placeholder="Finish start"
                        :clearable="false"
                        :error="$v.transfer.estimated_finish_date.$error"
                      />
                      <template #error>
                        <div v-if="$v.transfer.estimated_finish_date.$dirty && !$v.transfer.estimated_finish_date.required">Required field</div>
                        <div v-if="$v.transfer.estimated_finish_date.$dirty && !$v.transfer.estimated_finish_date.minValue">
                          Date cannot be less than the current date
                        </div>
                      </template>
                    </app-form-group>
                    <app-form-group label="Finish time" label-for="reported_time" class="form-group--no-indent" required>
                      <app-input
                          v-model="transfer.estimated_finish_time"
                          v-mask="'99:99'"
                          placeholder="00:00"
                          autocomplete="off"
                          id="reported_time"
                          name="reported_time"
                          @paste.native.prevent
                          :error="$v.transfer.estimated_finish_time.$error"
                      />
                      <template #error>
                        <div v-if="$v.transfer.estimated_finish_time.$dirty && !$v.transfer.estimated_finish_time.required">Required field</div>
                        <div v-if="$v.transfer.estimated_finish_time.$dirty && !$v.transfer.estimated_finish_time.timeRegex">Wrong time</div>
                      </template>
                    </app-form-group>
                  </div>
                  <app-form-group label="Notes" label-for="transfer_notes">
                    <app-textarea
                        v-model="transfer.notes"
                        rows="4"
                        placeholder="Write a notes"
                        id="transfer_notes"
                    />
                  </app-form-group>
                </template>
                <template #item-2>
                  <div class="arrange-popup__subtitle">Transport</div>
                  <div class="arrange-popup__part">
                    <div class="arrange-popup__block-title">
                      <span>Own cars</span>
                      <button @click="onAddOwnCar('transfer')" type="button">
                        <img src="@/assets/img/add-big-button-icon.svg" alt="">
                      </button>
                    </div>
                    <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                      <div v-for="(element, index) in transfer.own_cars" :key="`own_item_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row transfer-sortable__row--pr">
                          <app-form-group class="form-group--no-indent" required>
                            <app-select
                              @input="onOwnCarSelected(element.car, index, 'transfer')"
                              v-model="element.car"
                              :options="cars_options"
                              :clearable="false"
                              label="plate_number"
                              placeholder="Select car"
                              :error="$v.transfer.own_cars.$each[index].car.$error"
                            />
                            <template #error>
                              <div v-if="$v.transfer.own_cars.$each[index].car.$dirty && !$v.transfer.own_cars.$each[index].car.required">Required field</div>
                            </template>
                          </app-form-group>
                          <app-form-group class="form-group--no-indent" required>
                            <app-select
                              v-model="element.driver"
                              :options="drivers_options"
                              :clearable="false"
                              label="full_name"
                              placeholder="Enter driver"
                              :error="$v.transfer.own_cars.$each[index].driver.$error"
                            />
                            <template #error>
                              <div v-if="$v.transfer.own_cars.$each[index].driver.$dirty && !$v.transfer.own_cars.$each[index].driver.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button
                              @click="onRemoveOwnItem(index, 'transfer')"
                              class="transfer-sortable__close"
                              type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="">
                          </button>
                        </div>
                        <div class="transfer-sortable__row">
                          <app-cells :indent="false">
                            Driver confirmed: <app-switcher v-model="element.driver_confirmed" :readonly="!element.driver" />
                          </app-cells>
                          <app-cells v-if="transfer.is_kilimanjaro_np_gate_transfer" :indent="false">
                            Transport guests: <app-switcher v-model="element.transport_guests" :readonly="!element.car" />
                          </app-cells>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="arrange-popup__part">
                    <div class="arrange-popup__block-title">
                      <span>Rental</span>
                      <button @click="onAddRental('transfer')" type="button">
                        <img src="@/assets/img/add-big-button-icon.svg" alt="">
                      </button>
                    </div>
                    <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                      <div v-for="(element, index) in transfer.rental_cars" :key="`rental_item_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row transfer-sortable__row--pr">
                          <app-form-group class="form-group--no-indent" required>
                            <app-select
                              @input="onRentalCompanySelected(element.rental_company, index)"
                              v-model="element.rental_company"
                              :options="company_options"
                              :clearable="false"
                              placeholder="Select company"
                              :error="$v.transfer.rental_cars.$each[index].rental_company.$error"
                            />
                            <template #error>
                              <div v-if="$v.transfer.rental_cars.$each[index].rental_company.$dirty && !$v.transfer.rental_cars.$each[index].rental_company.required">Required field</div>
                            </template>
                          </app-form-group>
                          <app-form-group class="form-group--no-indent" required>
                            <app-select
                              @input="onRentalCarModelSelected(element.car_model.id, index, 'transfer')"
                              v-model="element.car_model"
                              :options="rental_options[index].models_options"
                              :clearable="false"
                              label="name"
                              placeholder="Select car model"
                              :readonly="!element.rental_company"
                              :error="{'select--error': $v.transfer.rental_cars.$each[index].car_model.$error}"
                            />
                            <template #error>
                              <div v-if="$v.transfer.rental_cars.$each[index].car_model.$dirty && !$v.transfer.rental_cars.$each[index].car_model.required">Required field</div>
                            </template>
                          </app-form-group>
                        </div>
                        <div class="transfer-sortable__row transfer-sortable__row--mix transfer-sortable__row--pr">
                          <app-form-group class="form-group--no-indent" required>
                            <app-select
                              @input="onRentalCarSelected(element.car, index, 'transfer')"
                              v-model="element.car"
                              :options="rental_options[index].cars_options"
                              :clearable="false"
                              label="plate_number"
                              placeholder="Select car"
                              :readonly="!element.car_model"
                            />
                          </app-form-group>
                          <app-form-group class="form-group--no-indent" required>
                            <app-select
                              v-model="element.driver"
                              :options="rental_options[index].drivers_options"
                              :clearable="false"
                              label="full_name"
                              placeholder="Select driver"
                              :readonly="!element.car"
                            />
                          </app-form-group>
                          <div class="arrange-popup__cost">
                            <span>Price (TSh):</span>
                            <app-form-group class="form-group--no-indent">
                              <app-input
                                  v-model.number="element.rental_cost"
                                  type="number"
                                  placeholder="0"
                                  id="cost"
                                  name="cost"
                                  class="input--100"
                                  :error="$v.transfer.rental_cars.$each[index].rental_cost.$error"
                              />
                              <template #error>
                                <div v-if="$v.transfer.rental_cars.$each[index].rental_cost.$dirty && !$v.transfer.rental_cars.$each[index].rental_cost.required">Required field</div>
                              </template>
                            </app-form-group>
                          </div>
                        </div>
                        <button
                            @click="onRemoveRentalItem(index, 'transfer')"
                            class="transfer-sortable__close"
                            type="button"
                        >
                          <img src="@/assets/img/delete-transfer.svg" alt="">
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="arrange-popup__part">
                    <div class="arrange-popup__block-title">
                      <span>Taxi</span>
                      <button @click="onAddTaxi('transfer')" type="button">
                        <img src="@/assets/img/add-big-button-icon.svg" alt="">
                      </button>
                    </div>
                    <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                      <div v-for="(element, index) in transfer.taxi" :key="`taxi_item_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row transfer-sortable__row--mix transfer-sortable__row--pr">
                          <app-form-group class="form-group--no-indent" required>
                            <app-select
                              v-model="element.taxi_driver"
                              :options="taxi_options"
                              :clearable="false"
                              label="full_name"
                              placeholder="Select taxi"
                              :error="$v.transfer.taxi.$each[index].taxi_driver.$error"
                            />
                            <template #error>
                              <div v-if="$v.transfer.taxi.$each[index].taxi_driver.$dirty && !$v.transfer.taxi.$each[index].taxi_driver.required">Required field</div>
                            </template>
                          </app-form-group>
                          <span v-if="element.taxi_driver">
                        {{ element.taxi_driver.car_model.name }} ({{ element.taxi_driver.plate_number }})
                      </span>
                          <div class="arrange-popup__cost">
                            <span>Price (TSh):</span>
                            <app-form-group class="form-group--no-indent">
                              <app-input
                                  v-model.number="element.cost"
                                  type="number"
                                  placeholder="0"
                                  id="cost"
                                  name="cost"
                                  class="input--100"
                                  :error="$v.transfer.taxi.$each[index].cost.$error"
                              />
                              <template #error>
                                <div v-if="$v.transfer.taxi.$each[index].cost.$dirty && !$v.transfer.taxi.$each[index].cost.required">Required field</div>
                              </template>
                            </app-form-group>
                          </div>
                          <button
                              @click="onRemoveTaxiItem(index, 'transfer')"
                              class="transfer-sortable__close"
                              type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="">
                          </button>
                        </div>
                        <div class="transfer-sortable__row">
                          <app-cells :indent="false">
                            Driver confirmed: <app-switcher v-model="element.driver_confirmed" :readonly="!element.taxi_driver" />
                          </app-cells>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </app-grid>
            </div>
            <app-cells position="center" :indent="false">
              <app-button
                v-if="transfer.status.code === 'arranged' && !transfer.own_cars.length && !transfer.rental_cars.length && !transfer.taxi.length"
                @click.native="$modal.show('return-to-requested-modal')"
                theme="warn"
                type="button"
              >
                Return to Requested
              </app-button>
              <app-button
                  :disabled="$v.transfer.$error || (!transfer.own_cars.length && !transfer.rental_cars.length && !transfer.taxi.length)"
                  type="submit"
                  ref="submit"
              >
                Arrange transfer
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="return-to-requested-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('return-to-requested-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Remove transport
        </div>
        <div class="popup__body">
          <div class="popup__subt">All assigned vehicles and drivers will be removed. The transfer will remain open as Requested.</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('return-to-requested-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="returnToRequested" ref="return_to_requested">Confirm</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
        name="accept-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to cancelled this transfer?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="cancelTransfer" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
        name="accept-delete-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to deleted this transfer?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="deleteTransfer" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
        name="staff-modal"
        :width="750"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('staff-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit transfer</div>
        <div v-if="staff_form" class="popup__body">
          <form @submit.prevent="onCheckEditStaffForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                        v-model="staff_form.name"
                        placeholder="Name"
                        id="name"
                        name="tr_name"
                        :error="$v.staff_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.staff_form.name.$dirty && !$v.staff_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="staff_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.staff_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.staff_form.pick_up_date.$dirty && !$v.staff_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.staff_form.pick_up_date.$dirty && !$v.staff_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                            v-model="staff_form.pick_up_time"
                            v-mask="'99:99'"
                            placeholder="Time"
                            autocomplete="off"
                            id="pick_up_time-time"
                            name="pick_up_time"
                            @paste.native.prevent
                            :error="$v.staff_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.staff_form.pick_up_time.$dirty && !$v.staff_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.staff_form.pick_up_time.$dirty && !$v.staff_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onPickUpPointSelected(staff_form.pick_up_point, 'staff')"
                      @search="onLocationSearch"
                      v-model="staff_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.staff_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.staff_form.pick_up_point.$dirty && !$v.staff_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <draggable
                      :list="staff_form.points"
                      v-bind="dragOptions"
                      handle=".sortable__handle"
                      class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in staff_form.points" :key="`staff_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                                @input="onLocationSelected(element.location, index, 'staff')"
                                @search="onLocationSearch"
                                v-model="element.location"
                                :options="location_options"
                                :filterable="false"
                                :clearable="false"
                                placeholder="Select"
                                :error="$v.staff_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.staff_form.points.$each[index].location.$dirty && !$v.staff_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                              v-if="index !== 0"
                              @click="onRemoveDestination('staff', index)"
                              class="transfer-sortable__close"
                              type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddDestination('staff')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Other pax" label-for="other_pax">
                    <app-input
                        v-model="staff_form.other_pax"
                        placeholder="Other pax"
                        id="other_pax-time"
                        name="other_pax"
                    />
                  </app-form-group>
                  <app-form-group label="Staff">
                    <app-select
                      @search="onEmployeeSearch"
                      v-model="staff_form.employees"
                      :options="employees_options"
                      label="full_name"
                      placeholder="Staff"
                      multiple
                    />
                  </app-form-group>
                </template>
              </app-grid>
              <app-form-group label="Notes" label-for="notes">
                <app-textarea
                    v-model="staff_form.notes"
                    id="notes"
                    placeholder="Notes"
                />
              </app-form-group>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="staff_submit">Save transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
        name="create-staff-modal"
        :width="800"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        draggable=".popup__title"
        :reset="true"
        class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('create-staff-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Request staff transfer</div>
        <div v-if="create_staff_form" class="popup__body">
          <form @submit.prevent="onCheckCreateStaffForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                        v-model="create_staff_form.name"
                        placeholder="Name"
                        id="name"
                        name="tr_name"
                        :error="$v.create_staff_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.create_staff_form.name.$dirty && !$v.create_staff_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onStaffPickUpPointSelected(create_staff_form.pick_up_point, 'create_staff_form', 'create_staff_submit')"
                      @search="onLocationSearch"
                      v-model="create_staff_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.create_staff_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.create_staff_form.pick_up_point.$dirty && !$v.create_staff_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="create_staff_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.create_staff_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.create_staff_form.pick_up_date.$dirty && !$v.create_staff_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.create_staff_form.pick_up_date.$dirty && !$v.create_staff_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                            v-model="create_staff_form.pick_up_time"
                            v-mask="'99:99'"
                            placeholder="Time"
                            autocomplete="off"
                            id="pick_up_time-time"
                            name="pick_up_time"
                            @paste.native.prevent
                            :error="$v.create_staff_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.create_staff_form.pick_up_time.$dirty && !$v.create_staff_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.create_staff_form.pick_up_time.$dirty && !$v.create_staff_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <draggable
                      :list="create_staff_form.points"
                      v-bind="dragOptions"
                      handle=".sortable__handle"
                      class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in create_staff_form.points" :key="`create_staff_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                                @input="onStaffLocationSelected(element.location, index, 'create_staff_form', 'create_staff_submit')"
                                @search="onLocationSearch"
                                v-model="element.location"
                                :options="location_options"
                                :filterable="false"
                                :clearable="false"
                                placeholder="Select"
                                :error="$v.create_staff_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.create_staff_form.points.$each[index].location.$dirty && !$v.create_staff_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                              v-if="index !== 0"
                              @click="onRemoveStaffDestination(index, 'create_staff_form')"
                              class="transfer-sortable__close"
                              type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddStaffDestination('create_staff_form')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Other pax" label-for="other_pax">
                    <app-input
                        v-model.number="create_staff_form.other_pax"
                        placeholder="Other pax"
                        id="other_pax"
                        name="other_pax"
                        type="number"
                    />
                  </app-form-group>
                  <app-form-group label="Staff">
                    <app-select
                      @search="onEmployeeSearch"
                      v-model="create_staff_form.employees"
                      :options="employees_options"
                      label="full_name"
                      placeholder="Staff"
                      multiple
                    />
                  </app-form-group>
                </template>
              </app-grid>
              <app-form-group label="Notes" label-for="notes">
                <app-textarea
                    v-model="create_staff_form.notes"
                    id="notes"
                    placeholder="Notes"
                />
              </app-form-group>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="create_staff_submit">Request transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="hotel-arrival"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('hotel-arrival')" class="popup__close" type="button"></button>
        <div class="popup__title">Request Hotel Arrival transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckHotelArrivalForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                      v-model="hotel_arrival_form.name"
                      placeholder="Name"
                      id="name"
                      name="tr_name"
                      :error="$v.hotel_arrival_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_arrival_form.name.$dirty && !$v.hotel_arrival_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onStaffPickUpPointSelected(hotel_arrival_form.pick_up_point, 'hotel_arrival_form', 'hotel_arrival_submit')"
                      @search="onLocationSearch"
                      v-model="hotel_arrival_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.hotel_arrival_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_arrival_form.pick_up_point.$dirty && !$v.hotel_arrival_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="hotel_arrival_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.hotel_arrival_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_arrival_form.pick_up_date.$dirty && !$v.hotel_arrival_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.hotel_arrival_form.pick_up_date.$dirty && !$v.hotel_arrival_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                          v-model="hotel_arrival_form.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="Time"
                          autocomplete="off"
                          id="pick_up_time-time"
                          name="pick_up_time"
                          @paste.native.prevent
                          :error="$v.hotel_arrival_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_arrival_form.pick_up_time.$dirty && !$v.hotel_arrival_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.hotel_arrival_form.pick_up_time.$dirty && !$v.hotel_arrival_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <draggable
                    :list="hotel_arrival_form.points"
                    v-bind="dragOptions"
                    handle=".sortable__handle"
                    class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in hotel_arrival_form.points" :key="`hotel_arrival_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                              @input="onStaffLocationSelected(element.location, index, 'hotel_arrival_form', 'hotel_arrival_submit')"
                              @search="onLocationSearch"
                              v-model="element.location"
                              :options="location_options"
                              :filterable="false"
                              :clearable="false"
                              placeholder="Select"
                              :error="$v.hotel_arrival_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.hotel_arrival_form.points.$each[index].location.$dirty && !$v.hotel_arrival_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                            v-if="index !== 0"
                            @click="onRemoveStaffDestination(index, 'hotel_arrival_form')"
                            class="transfer-sortable__close"
                            type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddStaffDestination('hotel_arrival_form')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Pax" label-for="arrival_pax" required>
                    <app-input
                      v-model.number="hotel_arrival_form.other_pax"
                      placeholder="Pax"
                      id="arrival_pax"
                      name="arrival_pax"
                      type="number"
                      :error="$v.hotel_arrival_form.other_pax.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_arrival_form.other_pax.$dirty && !$v.hotel_arrival_form.other_pax.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Notes" label-for="notes">
                    <app-textarea
                      v-model="hotel_arrival_form.notes"
                      id="notes"
                      placeholder="Notes"
                    />
                  </app-form-group>
                </template>
              </app-grid>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="hotel_arrival_submit">Request transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="hotel_arrival-modal"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('hotel_arrival-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckHotelArrivalEditForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                      v-model="hotel_arrival_form.name"
                      placeholder="Name"
                      id="name"
                      name="tr_name"
                      :error="$v.hotel_arrival_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_arrival_form.name.$dirty && !$v.hotel_arrival_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onStaffPickUpPointSelected(hotel_arrival_form.pick_up_point, 'hotel_arrival_form', 'hotel_arrival_submit')"
                      @search="onLocationSearch"
                      v-model="hotel_arrival_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.hotel_arrival_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_arrival_form.pick_up_point.$dirty && !$v.hotel_arrival_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="hotel_arrival_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.hotel_arrival_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_arrival_form.pick_up_date.$dirty && !$v.hotel_arrival_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.hotel_arrival_form.pick_up_date.$dirty && !$v.hotel_arrival_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                          v-model="hotel_arrival_form.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="Time"
                          autocomplete="off"
                          id="pick_up_time-time"
                          name="pick_up_time"
                          @paste.native.prevent
                          :error="$v.hotel_arrival_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_arrival_form.pick_up_time.$dirty && !$v.hotel_arrival_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.hotel_arrival_form.pick_up_time.$dirty && !$v.hotel_arrival_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <draggable
                    :list="hotel_arrival_form.points"
                    v-bind="dragOptions"
                    handle=".sortable__handle"
                    class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in hotel_arrival_form.points" :key="`hotel_arrival_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                              @input="onStaffLocationSelected(element.location, index, 'hotel_arrival_form', 'hotel_arrival_submit')"
                              @search="onLocationSearch"
                              v-model="element.location"
                              :options="location_options"
                              :filterable="false"
                              :clearable="false"
                              placeholder="Select"
                              :error="$v.hotel_arrival_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.hotel_arrival_form.points.$each[index].location.$dirty && !$v.hotel_arrival_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                            v-if="index !== 0"
                            @click="onRemoveStaffDestination(index, 'hotel_arrival_form')"
                            class="transfer-sortable__close"
                            type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddStaffDestination('hotel_arrival_form')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Pax" label-for="arrival_pax" required>
                    <app-input
                      v-model.number="hotel_arrival_form.other_pax"
                      placeholder="Pax"
                      id="arrival_pax"
                      name="arrival_pax"
                      type="number"
                      :error="$v.hotel_arrival_form.other_pax.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_arrival_form.other_pax.$dirty && !$v.hotel_arrival_form.other_pax.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Notes" label-for="notes">
                    <app-textarea
                      v-model="hotel_arrival_form.notes"
                      id="notes"
                      placeholder="Notes"
                    />
                  </app-form-group>
                </template>
              </app-grid>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="hotel_arrival_submit">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="hotel-departure"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('hotel-departure')" class="popup__close" type="button"></button>
        <div class="popup__title">Request Hotel Departure transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckHotelDepartureForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                      v-model="hotel_departure_form.name"
                      placeholder="Name"
                      id="name"
                      name="tr_name"
                      :error="$v.hotel_departure_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_departure_form.name.$dirty && !$v.hotel_departure_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onStaffPickUpPointSelected(hotel_departure_form.pick_up_point, 'hotel_departure_form', 'hotel_departure_submit')"
                      @search="onLocationSearch"
                      v-model="hotel_departure_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.hotel_departure_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_departure_form.pick_up_point.$dirty && !$v.hotel_departure_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="hotel_departure_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.hotel_departure_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_departure_form.pick_up_date.$dirty && !$v.hotel_departure_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.hotel_departure_form.pick_up_date.$dirty && !$v.hotel_departure_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                          v-model="hotel_departure_form.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="Time"
                          autocomplete="off"
                          id="pick_up_time-time"
                          name="pick_up_time"
                          @paste.native.prevent
                          :error="$v.hotel_departure_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_departure_form.pick_up_time.$dirty && !$v.hotel_departure_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.hotel_departure_form.pick_up_time.$dirty && !$v.hotel_departure_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <draggable
                    :list="hotel_departure_form.points"
                    v-bind="dragOptions"
                    handle=".sortable__handle"
                    class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in hotel_departure_form.points" :key="`hotel_departure_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                              @input="onStaffLocationSelected(element.location, index, 'hotel_departure_form', 'hotel_departure_submit')"
                              @search="onLocationSearch"
                              v-model="element.location"
                              :options="location_options"
                              :filterable="false"
                              :clearable="false"
                              placeholder="Select"
                              :error="$v.hotel_departure_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.hotel_departure_form.points.$each[index].location.$dirty && !$v.hotel_departure_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                            v-if="index !== 0"
                            @click="onRemoveStaffDestination(index, 'hotel_departure_form')"
                            class="transfer-sortable__close"
                            type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddStaffDestination('hotel_departure_form')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Pax" label-for="departure_pax" required>
                    <app-input
                      v-model.number="hotel_departure_form.other_pax"
                      placeholder="Pax"
                      id="departure_pax"
                      name="departure_pax"
                      type="number"
                      :error="$v.hotel_departure_form.other_pax.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_departure_form.other_pax.$dirty && !$v.hotel_departure_form.other_pax.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Notes" label-for="notes">
                    <app-textarea
                      v-model="hotel_departure_form.notes"
                      id="notes"
                      placeholder="Notes"
                    />
                  </app-form-group>
                </template>
              </app-grid>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="hotel_departure_submit">Request transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="hotel_departure-modal"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('hotel_departure-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckHotelDepartureEditForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                      v-model="hotel_departure_form.name"
                      placeholder="Name"
                      id="name"
                      name="tr_name"
                      :error="$v.hotel_departure_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_departure_form.name.$dirty && !$v.hotel_departure_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onStaffPickUpPointSelected(hotel_departure_form.pick_up_point, 'hotel_departure_form', 'hotel_departure_submit')"
                      @search="onLocationSearch"
                      v-model="hotel_departure_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.hotel_departure_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_departure_form.pick_up_point.$dirty && !$v.hotel_departure_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="hotel_departure_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.hotel_departure_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_departure_form.pick_up_date.$dirty && !$v.hotel_departure_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.hotel_departure_form.pick_up_date.$dirty && !$v.hotel_departure_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                          v-model="hotel_departure_form.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="Time"
                          autocomplete="off"
                          id="pick_up_time-time"
                          name="pick_up_time"
                          @paste.native.prevent
                          :error="$v.hotel_departure_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_departure_form.pick_up_time.$dirty && !$v.hotel_departure_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.hotel_departure_form.pick_up_time.$dirty && !$v.hotel_departure_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <draggable
                    :list="hotel_departure_form.points"
                    v-bind="dragOptions"
                    handle=".sortable__handle"
                    class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in hotel_departure_form.points" :key="`hotel_departure_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                              @input="onStaffLocationSelected(element.location, index, 'hotel_departure_form', 'hotel_departure_submit')"
                              @search="onLocationSearch"
                              v-model="element.location"
                              :options="location_options"
                              :filterable="false"
                              :clearable="false"
                              placeholder="Select"
                              :error="$v.hotel_departure_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.hotel_departure_form.points.$each[index].location.$dirty && !$v.hotel_departure_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                            v-if="index !== 0"
                            @click="onRemoveStaffDestination(index, 'hotel_departure_form')"
                            class="transfer-sortable__close"
                            type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddStaffDestination('hotel_departure_form')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Pax" label-for="departure_pax" required>
                    <app-input
                      v-model.number="hotel_departure_form.other_pax"
                      placeholder="Pax"
                      id="departure_pax"
                      name="departure_pax"
                      type="number"
                      :error="$v.hotel_departure_form.other_pax.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_departure_form.other_pax.$dirty && !$v.hotel_departure_form.other_pax.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Notes" label-for="notes">
                    <app-textarea
                      v-model="hotel_departure_form.notes"
                      id="notes"
                      placeholder="Notes"
                    />
                  </app-form-group>
                </template>
              </app-grid>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="hotel_departure_submit">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="hotel-other"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('hotel-other')" class="popup__close" type="button"></button>
        <div class="popup__title">Request Hotel Other transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckHotelOtherForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                      v-model="hotel_other_form.name"
                      placeholder="Name"
                      id="name"
                      name="tr_name"
                      :error="$v.hotel_other_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_other_form.name.$dirty && !$v.hotel_other_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onStaffPickUpPointSelected(hotel_other_form.pick_up_point, 'hotel_other_form', 'hotel_other_submit')"
                      @search="onLocationSearch"
                      v-model="hotel_other_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.hotel_other_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_other_form.pick_up_point.$dirty && !$v.hotel_other_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="hotel_other_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.hotel_other_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_other_form.pick_up_date.$dirty && !$v.hotel_other_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.hotel_other_form.pick_up_date.$dirty && !$v.hotel_other_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                          v-model="hotel_other_form.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="Time"
                          autocomplete="off"
                          id="pick_up_time-time"
                          name="pick_up_time"
                          @paste.native.prevent
                          :error="$v.hotel_other_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_other_form.pick_up_time.$dirty && !$v.hotel_other_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.hotel_other_form.pick_up_time.$dirty && !$v.hotel_other_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <draggable
                    :list="hotel_other_form.points"
                    v-bind="dragOptions"
                    handle=".sortable__handle"
                    class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in hotel_other_form.points" :key="`hotel_arrival_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                              @input="onStaffLocationSelected(element.location, index, 'hotel_other_form', 'hotel_other_submit')"
                              @search="onLocationSearch"
                              v-model="element.location"
                              :options="location_options"
                              :filterable="false"
                              :clearable="false"
                              placeholder="Select"
                              :error="$v.hotel_other_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.hotel_other_form.points.$each[index].location.$dirty && !$v.hotel_other_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                            v-if="index !== 0"
                            @click="onRemoveStaffDestination(index, 'hotel_other_form')"
                            class="transfer-sortable__close"
                            type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddStaffDestination('hotel_other_form')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Pax" label-for="departure_pax" required>
                    <app-input
                      v-model.number="hotel_other_form.other_pax"
                      placeholder="Pax"
                      id="departure_pax"
                      name="departure_pax"
                      type="number"
                      :error="$v.hotel_other_form.other_pax.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_other_form.other_pax.$dirty && !$v.hotel_other_form.other_pax.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Notes" label-for="notes">
                    <app-textarea
                      v-model="hotel_other_form.notes"
                      id="notes"
                      placeholder="Notes"
                    />
                  </app-form-group>
                </template>
              </app-grid>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="hotel_other_submit">Request transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="hotel_other-modal"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('hotel_other-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckHotelOtherEditForm">
            <div class="arrival-popup">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Name" label-for="tr_name" required>
                    <app-input
                      v-model="hotel_other_form.name"
                      placeholder="Name"
                      id="name"
                      name="tr_name"
                      :error="$v.hotel_other_form.name.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_other_form.name.$dirty && !$v.hotel_other_form.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Pick-up point" required>
                    <app-select
                      @input="onStaffPickUpPointSelected(hotel_other_form.pick_up_point, 'hotel_other_form', 'hotel_other_submit')"
                      @search="onLocationSearch"
                      v-model="hotel_other_form.pick_up_point"
                      :options="location_options"
                      :filterable="false"
                      :clearable="false"
                      placeholder="Select"
                      :error="$v.hotel_other_form.pick_up_point.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_other_form.pick_up_point.$dirty && !$v.hotel_other_form.pick_up_point.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-grid>
                    <template #item-1>
                      <app-form-group label="Pick-up date" required>
                        <app-date-picker
                          v-model="hotel_other_form.pick_up_date"
                          placeholder="Specify a date"
                          :error="$v.hotel_other_form.pick_up_date.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_other_form.pick_up_date.$dirty && !$v.hotel_other_form.pick_up_date.required">Required field</div>
                          <div v-if="$v.hotel_other_form.pick_up_date.$dirty && !$v.hotel_other_form.pick_up_date.minValue">
                            Date cannot be less than the current date
                          </div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #item-2>
                      <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                        <app-input
                          v-model="hotel_other_form.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="Time"
                          autocomplete="off"
                          id="pick_up_time-time"
                          name="pick_up_time"
                          @paste.native.prevent
                          :error="$v.hotel_other_form.pick_up_time.$error"
                        />
                        <template #error>
                          <div v-if="$v.hotel_other_form.pick_up_time.$dirty && !$v.hotel_other_form.pick_up_time.required">Required field</div>
                          <div v-if="$v.hotel_other_form.pick_up_time.$dirty && !$v.hotel_other_form.pick_up_time.timeRegex">Wrong time</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-grid>
                  <draggable
                    :list="hotel_other_form.points"
                    v-bind="dragOptions"
                    handle=".sortable__handle"
                    class="transfer-sortable transfer-sortable--lite"
                  >
                    <transition-group type="transition" :name="'flip-list'" tag="div">
                      <div v-for="(element, index) in hotel_other_form.points" :key="`hotel_other_points_${index}`" class="transfer-sortable__item">
                        <div class="transfer-sortable__row">
                          <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                            <app-select
                              @input="onStaffLocationSelected(element.location, index, 'hotel_other_form', 'hotel_other_submit')"
                              @search="onLocationSearch"
                              v-model="element.location"
                              :options="location_options"
                              :filterable="false"
                              :clearable="false"
                              placeholder="Select"
                              :error="$v.hotel_other_form.points.$each[index].location.$error"
                            />
                            <template #error>
                              <div v-if="$v.hotel_other_form.points.$each[index].location.$dirty && !$v.hotel_other_form.points.$each[index].location.required">Required field</div>
                            </template>
                          </app-form-group>
                          <button type="button" class="transfer-sortable__btn sortable__handle">
                            <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                          </button>
                          <button
                            v-if="index !== 0"
                            @click="onRemoveStaffDestination(index, 'hotel_other_form')"
                            class="transfer-sortable__close"
                            type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <app-cells>
                    <app-button @click.native="onAddStaffDestination('hotel_other_form')" size="small">
                      <img src="@/assets/img/plus-icon.svg" alt="Add">
                      <span>Add destination</span>
                    </app-button>
                  </app-cells>
                </template>
                <template #item-2>
                  <app-form-group label="Pax" label-for="departure_pax" required>
                    <app-input
                      v-model.number="hotel_other_form.other_pax"
                      placeholder="Pax"
                      id="departure_pax"
                      name="departure_pax"
                      type="number"
                      :error="$v.hotel_other_form.other_pax.$error"
                    />
                    <template #error>
                      <div v-if="$v.hotel_other_form.other_pax.$dirty && !$v.hotel_other_form.other_pax.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Notes" label-for="notes">
                    <app-textarea
                      v-model="hotel_other_form.notes"
                      id="notes"
                      placeholder="Notes"
                    />
                  </app-form-group>
                </template>
              </app-grid>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="hotel_other_submit">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getCarManagementCars,
  getEmployeesListSearch,
  patchTransfers,
  getTransfersTaxiDriversList,
  getTransfersRentalCompanyList,
  getTransfersRentalCompanyCarsList,
  getTransfersRentalCompanyDriversList,
  postLocation,
  getGoogleSearch,
  getClientsLite,
  patchArrivalTransfer,
  patchDepartureTransfer,
  patchOtherTransfer,
  patchStaffTransfer,
  postTransferStaff,
  patchSafariTransfer,
  patchClimbingTransfer,
  patchDayTripTransfer,
  getTransfersDatesList,
  deleteTransfer,
  postTransferReturnToRequested,
  postTransferHotelArrival,
  patchTransferHotelArrival,
  postTransferHotelDeparture,
  patchTransferHotelDeparture,
  postTransferHotelOther,
  patchTransferHotelOther
} from '@/http'
import TransfersBlocks from '@/views/transfer/transfers/TransfersBlocks'
import { format, parse } from 'date-fns'
import { helpers, required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)
import draggable from 'vuedraggable'

export default {
  name: 'TransfersRequested',
  components: { TransfersBlocks, draggable },
  data() {
    return {
      rental_options: [],
      is_loaded: false,
      arranged_transfers: [],
      requested_transfers: [],
      pagination_requested: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_requested_length: 0,
      need_transfers: [],
      transfer: null,
      cars_options: [],
      drivers_options: [],
      taxi_options: [],
      company_options: [],
      rental_cars_options: [],
      rental_drivers_options: [],
      location_options: [],
      clients_options: [],
      employees_options: [],
      current_transfer_id: null,
      staff_form: null,
      create_staff_form: {
        points: [{ location: null }]
      },
      search: '',
      filter_date: '',
      filter: 'requested,arranged',
      filters: [
        { value: 'requested,arranged', label: 'All' },
        { value: 'requested', label: 'Requested' },
        { value: 'arranged', label: 'Arranged' },
      ],
      filter_car: '',
      filter_driver: '',
      hotel_arrival_form: {
        points: [{ location: null }]
      },
      hotel_departure_form: {
        points: [{ location: null }]
      },
      hotel_other_form: {
        points: [{ location: null }]
      },
    }
  },
  validations: {
    transfer: {
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: { required, timeRegex },
      start_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      start_time: { required, timeRegex },
      estimated_finish_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      estimated_finish_time: { required, timeRegex },
      own_cars: {
        $each: {
          car: { required },
          driver: { required },
        }
      },
      taxi: {
        $each: {
          taxi_driver: { required },
          cost: { required },
        }
      },
      rental_cars: {
        $each: {
          rental_company: { required },
          car_model: { required },
          rental_cost: { required },
        }
      }
    },
    staff_form: {
      name: { required },
      points: {
        $each: {
          location: { required },
        }
      },
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required,
        timeRegex
      },
      pick_up_point: { required }
    },
    create_staff_form: {
      name: { required },
      points: {
        $each: {
          location: { required },
        }
      },
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required,
        timeRegex
      },
      pick_up_point: { required }
    },
    hotel_arrival_form: {
      name: { required },
      points: {
        $each: {
          location: { required },
        }
      },
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required,
        timeRegex
      },
      pick_up_point: { required },
      other_pax: { required },
    },
    hotel_departure_form: {
      name: { required },
      points: {
        $each: {
          location: { required },
        }
      },
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required,
        timeRegex
      },
      pick_up_point: { required },
      other_pax: { required },
    },
    hotel_other_form: {
      name: { required },
      points: {
        $each: {
          location: { required },
        }
      },
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required,
        timeRegex
      },
      pick_up_point: { required },
      other_pax: { required },
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'destination',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    is_show_create_staff_button() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('operations_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('transfer_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('transfer_supervisor')
        || this.$store.state.userGroups.map(item => item.code).includes('transfer_assistant')
        || this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
        || this.$store.state.userGroups.map(item => item.code).includes('hotel_reception')
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_transfer_department() {
      return this.$store.state.userGroups.map(item => item.code).includes('transfer_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('transfer_supervisor')
        || this.$store.state.userGroups.map(item => item.code).includes('transfer_assistant')
        || this.$store.state.userGroups.map(item => item.code).includes('hotel_supervisor')
        || this.$store.state.userGroups.map(item => item.code).includes('hotel_reception')
        || this.$store.state.userGroups.map(item => item.code).includes('hotel_reservations')
    },
  },
  created() {
    this.fetchItems()
    getCarManagementCars({ available_for_transfers: true }).then(res => { this.cars_options = res.data })
    getEmployeesListSearch({ position: 'driver', employment_status: 'working' })
      .then(res => { this.drivers_options = res.data })
    getTransfersTaxiDriversList().then(res => { this.taxi_options = res.data })
    getTransfersRentalCompanyList().then(res => { this.company_options = res.data })
  },
  methods: {
    fetchItems() {
      this.is_loaded = false
      Promise.all([
        getTransfersDatesList({
          group_by: 'pick_up_date',
          range_type: 'day',
          search: this.search,
          status: 'arranged',
          compact: true,
          category: 'upcoming',
          from_date: this.filter_date,
          to_date: this.filter_date,
          confirmed: false
        }),
        getTransfersDatesList({
          group_by: 'pick_up_date',
          range_type: 'day',
          search: this.search,
          status: 'need_amended',
          compact: true,
          category: 'upcoming',
          from_date: this.filter_date,
          to_date: this.filter_date
        }),
        getTransfersDatesList({
          page: this.pagination_requested.page,
          page_size: 60,
          group_by: 'pick_up_date',
          range_type: 'day',
          search: this.search,
          status: this.filter,
          compact: true,
          category: 'upcoming',
          from_date: this.filter_date,
          to_date: this.filter_date,
          confirmed: true,
          own_cars: this.filter_car,
          driver: this.filter_driver
        })
      ])
        .then(res => {
          this.arranged_transfers = res[0].data
          this.need_transfers = res[1].data
          this.requested_transfers = res[2].data.results
          this.pagination_requested.pages = res[2].data.pages
          this.pagination_requested.count = res[2].data.count
          this.table_requested_length = 0
          res[2].data.results.forEach(item => {
            this.table_requested_length += item.items.length
          })
          this.is_loaded = true
        })
    },
    onClickPagination(page) {
      this.is_loaded = false
      this.pagination_requested.page = page
      getTransfersDatesList({
        page: this.pagination_requested.page,
        page_size: 60,
        group_by: 'pick_up_date',
        range_type: 'day',
        search: this.search,
        status: this.filter,
        compact: true,
        category: 'upcoming',
        from_date: this.filter_date,
        to_date: this.filter_date,
        confirmed: true,
        own_cars: this.filter_car,
        driver: this.filter_driver
      })
        .then(res => {
          this.requested_transfers = res.data.results
          this.pagination_requested.pages = res.data.pages
          this.pagination_requested.count = res.data.count
          this.table_requested_length = 0
          res.data.results.forEach(item => {
            this.table_requested_length += item.items.length
          })
          this.is_loaded = true
        })
    },
    onChangeFilter() {
      this.onFiltersChange()
    },
    onFiltersChange() {
      this.pagination_requested.page = 1
      this.fetchItems()
    },
    onTransferSearch() {
      this.filter_car = null
      this.filter_driver = null
      this.pagination_requested.page = 1
      this.searchTransfer(this)
    },
    searchTransfer: debounce(vm => {
      vm.fetchItems()
    }, 350),
    onOpenEditPopup(transfer) {
      this[`${transfer.type.code}_form`] = { ...transfer, points: [ ...transfer.points ] }
      this.$modal.show(`${transfer.type.code}-modal`)
    },
    onCheckHotelArrivalEditForm() {
      this.$v.hotel_arrival_form.$touch()
      if (this.$v.hotel_arrival_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendHotelArrivalEditForm()
      }
    },
    sendHotelArrivalEditForm() {
      this.$refs.hotel_arrival_submit.preload = true
      patchTransferHotelArrival(this.hotel_arrival_form.id, this.normalizeHotelArrivalForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer saved',
          })
          this.$modal.hide('hotel_arrival-modal')
          this.fetchItems()
        })
        .catch(() => { this.$refs.hotel_arrival_submit.preload = false })
    },
    onCheckHotelOtherEditForm() {
      this.$v.hotel_other_form.$touch()
      if (this.$v.hotel_other_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendHotelOtherEditForm()
      }
    },
    sendHotelOtherEditForm() {
      this.$refs.hotel_other_submit.preload = true
      patchTransferHotelOther(this.hotel_other_form.id, this.normalizeHotelOtherForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer saved',
          })
          this.$modal.hide('hotel_other-modal')
          this.fetchItems()
        })
        .catch(() => { this.$refs.hotel_other_submit.preload = false })
    },
    onCheckHotelDepartureEditForm() {
      this.$v.hotel_departure_form.$touch()
      if (this.$v.hotel_departure_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendHotelDepartureEditForm()
      }
    },
    sendHotelDepartureEditForm() {
      this.$refs.hotel_departure_submit.preload = true
      patchTransferHotelDeparture(this.hotel_departure_form.id, this.normalizeHotelDepartureForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer saved',
          })
          this.$modal.hide('hotel_departure-modal')
          this.fetchItems()
        })
        .catch(() => { this.$refs.hotel_departure_submit.preload = false })
    },
    onCheckHotelOtherForm() {
      this.$v.hotel_other_form.$touch()
      if (this.$v.hotel_other_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendHotelOtherForm()
      }
    },
    sendHotelOtherForm() {
      this.$refs.hotel_other_submit.preload = true
      postTransferHotelOther(this.normalizeHotelOtherForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer requested',
          })
          this.$modal.hide('hotel-other')
          this.fetchItems()
        })
        .catch(() => { this.$refs.hotel_other_submit.preload = false })
    },
    normalizeHotelOtherForm() {
      const form = {}

      form.points = [ ...this.hotel_other_form.points ].map((item, index) => ({ location: item.location.id, sort: index }))
      form.name = this.hotel_other_form.name
      form.other_pax = this.hotel_other_form.other_pax
      form.pick_up_date = this.hotel_other_form.pick_up_date
      form.pick_up_time = this.hotel_other_form.pick_up_time
      form.pick_up_point = this.hotel_other_form.pick_up_point.id
      form.notes = this.hotel_other_form.notes

      return form
    },
    onCheckHotelDepartureForm() {
      this.$v.hotel_departure_form.$touch()
      if (this.$v.hotel_departure_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendHotelDepartureForm()
      }
    },
    sendHotelDepartureForm() {
      this.$refs.hotel_departure_submit.preload = true
      postTransferHotelDeparture(this.normalizeHotelDepartureForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer requested',
          })
          this.$modal.hide('hotel-departure')
          this.fetchItems()
        })
        .catch(() => { this.$refs.hotel_departure_submit.preload = false })
    },
    normalizeHotelDepartureForm() {
      const form = {}

      form.points = [ ...this.hotel_departure_form.points ].map((item, index) => ({ location: item.location.id, sort: index }))
      form.name = this.hotel_departure_form.name
      form.other_pax = this.hotel_departure_form.other_pax
      form.pick_up_date = this.hotel_departure_form.pick_up_date
      form.pick_up_time = this.hotel_departure_form.pick_up_time
      form.pick_up_point = this.hotel_departure_form.pick_up_point.id
      form.notes = this.hotel_departure_form.notes

      return form
    },
    onCheckHotelArrivalForm() {
      this.$v.hotel_arrival_form.$touch()
      if (this.$v.hotel_arrival_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendHotelArrivalForm()
      }
    },
    sendHotelArrivalForm() {
      this.$refs.hotel_arrival_submit.preload = true
      postTransferHotelArrival(this.normalizeHotelArrivalForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer requested',
          })
          this.$modal.hide('hotel-arrival')
          this.fetchItems()
        })
        .catch(() => { this.$refs.hotel_arrival_submit.preload = false })
    },
    normalizeHotelArrivalForm() {
      const form = {}

      form.points = [ ...this.hotel_arrival_form.points ].map((item, index) => ({ location: item.location.id, sort: index }))
      form.name = this.hotel_arrival_form.name
      form.other_pax = this.hotel_arrival_form.other_pax
      form.pick_up_date = this.hotel_arrival_form.pick_up_date
      form.pick_up_time = this.hotel_arrival_form.pick_up_time
      form.pick_up_point = this.hotel_arrival_form.pick_up_point.id
      form.notes = this.hotel_arrival_form.notes

      return form
    },
    onCheckCreateStaffForm() {
      this.$v.create_staff_form.$touch()
      if (this.$v.create_staff_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendCreateStaffForm()
      }
    },
    sendCreateStaffForm() {
      this.$refs.create_staff_submit.preload = true
      postTransferStaff(this.normalizeCreateStaffForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer requested',
          })
          this.$modal.hide('create-staff-modal')
          this.fetchItems()
        })
        .catch(() => { this.$refs.create_staff_submit.preload = false })
    },
    normalizeCreateStaffForm() {
      const form = {}

      if (this.create_staff_form.employees) {
        form.employees = [ ...this.create_staff_form.employees ].map(item => item.id)
      }

      form.points = [ ...this.create_staff_form.points ].map((item, index) => ({ location: item.location.id, sort: index }))
      form.name = this.create_staff_form.name
      form.other_pax = this.create_staff_form.other_pax
      form.pick_up_date = this.create_staff_form.pick_up_date
      form.pick_up_time = this.create_staff_form.pick_up_time
      form.pick_up_point = this.create_staff_form.pick_up_point.id
      form.notes = this.create_staff_form.notes

      return form
    },
    onCheckEditStaffForm() {
      this.$v.staff_form.$touch()
      if (this.$v.staff_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendStaffForm()
      }
    },
    sendStaffForm() {
      this.$refs.staff_submit.preload = true
      patchStaffTransfer(this.staff_form.id, this.normalizeStaffForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer saved',
          })
          this.$modal.hide('staff-modal')
          this.fetchItems()
        })
        .catch(() => { this.$refs.staff_submit.preload = false })
    },
    normalizeStaffForm() {
      let points = [ ...this.staff_form.points ]
      let employees = [ ...this.staff_form.employees ]

      points = points.map((item, index) => ({ location: item.location.id, sort: index, id: item.id }))
      employees = employees.map(item => item.id)
      return {
        points,
        employees,
        name: this.staff_form.name,
        other_pax: this.staff_form.other_pax,
        pick_up_date: this.staff_form.pick_up_date,
        pick_up_time: this.staff_form.pick_up_time,
        pick_up_point: this.staff_form.pick_up_point.id,
        notes: this.staff_form.notes
      }
    },
    onRemoveDestination(type, index) {
      this[`${type}_form`].points.splice(index, 1)
      this.$v[`${type}_form`].points.$touch()
    },
    onAddDestination(type) {
      this[`${type}_form`].points.push({ location: null })
    },
    onRemoveStaffDestination(index, type) {
      this[type].points.splice(index, 1)
      this.$v[type].points.$touch()
    },
    onAddStaffDestination(type) {
      this[type].points.push({ location: null })
    },
    onLocationSelected({ name, place_id }, index, type) {
      this.$refs[`${type}_submit`].preload = true
      postLocation({ name, place_id }).then(res => {
        this[`${type}_form`].points[index].location = res.data
        this.$refs[`${type}_submit`].preload = false
      })
    },
    onStaffLocationSelected({ name, place_id }, index, type, ref) {
      this.$refs[ref].preload = true
      postLocation({ name, place_id }).then(res => {
        this[type].points[index].location = res.data
        this.$refs[ref].preload = false
      })
    },
    onPickUpPointSelected({ name, place_id }, type) {
      this.$refs[`${type}_submit`].preload = true
      postLocation({ name, place_id }).then(res => {
        this[`${type}_form`].pick_up_point = res.data
        this.$refs[`${type}_submit`].preload = false
      })
    },
    onStaffPickUpPointSelected({ name, place_id }, type, ref) {
      this.$refs[ref].preload = true
      postLocation({ name, place_id }).then(res => {
        this[type].pick_up_point = res.data
        this.$refs[ref].preload = false
      })
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          loading(false)
          vm.location_options = response.data
        })
      }
    }, 350),
    onCheckArrangeForm() {
      this.$v.transfer.$touch()
      if (this.$v.transfer.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (this.transfer.type.code === 'arrival') {
        patchArrivalTransfer(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'departure') {
        patchDepartureTransfer(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'other') {
        patchOtherTransfer(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'staff') {
        patchStaffTransfer(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'safari') {
        patchSafariTransfer(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'climbing') {
        patchClimbingTransfer(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'day_trip') {
        patchDayTripTransfer(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'hotel_arrival') {
        patchTransferHotelArrival(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'hotel_departure') {
        patchTransferHotelArrival(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else if (this.transfer.type.code === 'hotel_other') {
        patchTransferHotelArrival(this.transfer.id, this.normalizeArrangeForm())
          .then(() => {
            this.$modal.hide('arrange-popup')
            this.$refs.submit.preload = false
            this.fetchItems()
          })
          .catch(() => { this.$refs.submit.preload = false })
      }
    },
    normalizeArrangeForm() {
      let own_cars = [ ...this.transfer.own_cars ]
      let taxi = [ ...this.transfer.taxi ]
      let rental_cars = [ ...this.transfer.rental_cars ]

      if (own_cars.length) {
        own_cars = own_cars.map(item => ({
          car: item.car.id,
          driver: item.driver.id,
          id: item.id,
          driver_confirmed: item.driver_confirmed,
          transport_guests: item.transport_guests,
        }))
      }
      if (taxi.length) taxi = taxi.map(item => ({ taxi_driver: item.taxi_driver.id, cost: item.cost, id: item.id, driver_confirmed: item.driver_confirmed }))
      if (rental_cars.length) {
        rental_cars = rental_cars.map(item => ({
          rental_company: item.rental_company.id,
          car_model: item.car_model.id,
          id: item.id,
          rental_cost: item.rental_cost,
          driver: item.driver ? item.driver.id : null,
          car: item.car ? item.car.id : null,
        }))
        rental_cars.forEach(item => {
          if (!item.driver) delete item.driver
          if (!item.car) delete item.car
        })
      }
      return {
        status: 'arranged',
        pick_up_date: this.transfer.pick_up_date,
        pick_up_time: this.transfer.pick_up_time,
        start_date: this.transfer.start_date,
        start_time: this.transfer.start_time,
        estimated_finish_date: this.transfer.estimated_finish_date,
        estimated_finish_time: this.transfer.estimated_finish_time,
        notes: this.transfer.notes,
        own_cars,
        taxi,
        rental_cars
      }
    },
    returnToRequested() {
      this.$refs.return_to_requested.preload = true
      postTransferReturnToRequested(this.transfer.id)
        .then(() => {
          this.$modal.hide('return-to-requested-modal')
          this.$modal.hide('arrange-popup')
          this.$notify({ type: 'success', title: 'Transport removed; transfer is Requested' })
          this.fetchItems()
        })
        .catch(() => {})
        .finally(() => { this.$refs.return_to_requested.preload = false })
    },
    onCancelledTransfer(id) {
      this.current_transfer_id = id
      this.$modal.show('accept-modal')
    },
    cancelTransfer() {
      this.$refs.delete.preload = true
      patchTransfers(this.current_transfer_id, { status: 'cancelled' })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer cancelled',
          })
          this.fetchItems()
          this.$modal.hide('accept-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    onDeleteTransfer(id) {
      this.current_transfer_id = id
      this.$modal.show('accept-delete-modal')
    },
    deleteTransfer() {
      this.$refs.delete.preload = true
      deleteTransfer(this.current_transfer_id)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer deleted',
          })
          this.fetchItems()
          this.$modal.hide('accept-delete-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    onOwnCarSelected(car, index, type) {
      if (car.driver) this[type].own_cars[index].driver = car.driver
      else this[type].own_cars[index].driver = null
    },
    onRentalCarSelected(car, index, type) {
      if (car.driver) this[type].rental_cars[index].driver = car.driver
      else this[type].rental_cars[index].driver = null
    },
    onRentalCompanySelected(company, index) {
      getTransfersRentalCompanyDriversList(company.id).then(res => {
        this.rental_options[index].drivers_options = res.data
        this.rental_options[index].models_options = company.car_models
      })
    },
    onRentalCarModelSelected(car_model_id, index, type) {
      this[type].rental_cars[index].car = null
      this[type].rental_cars[index].driver = null
      getTransfersRentalCompanyCarsList(this[type].rental_cars[index].rental_company.id, { car_model: car_model_id })
        .then(res => { this.rental_options[index].cars_options = res.data })
    },
    onAddOwnCar(type) {
      this[type].own_cars.push({
        car: null,
        driver: null,
        transport_guests: true,
      })
    },
    onAddTaxi(type) {
      this[type].taxi.push({ taxi_driver: null })
    },
    onAddRental(type) {
      this.rental_options.push({ models_options: [], cars_options: [], drivers_options: [] })
      this[type].rental_cars.push({ rental_company: null, car_model: null, car: null, driver: null })
    },
    onRemoveOwnItem(index, type) {
      this[type].own_cars.splice(index, 1)
    },
    onRemoveTaxiItem(index, type) {
      this[type].taxi.splice(index, 1)
    },
    onRemoveRentalItem(index, type) {
      this[type].rental_cars.splice(index, 1)
      this.rental_options.splice(index, 1)
    },
    onArrangePopupOpen(transfer) {
      this.$v.transfer.$reset()
      this.transfer = {
        ...transfer,
        own_cars: transfer.own_cars.map(item => ({ ...item })),
        rental_cars: transfer.rental_cars.map(item => ({ ...item })),
        taxi: transfer.taxi.map(item => ({ ...item })),
      }
      if (this.transfer.rental_cars.length) {
        this.rental_options = this.transfer.rental_cars.map(item => ({
          models_options: this.company_options.find(company => company.id === item.rental_company.id).car_models,
          cars_options: item.rental_company.cars,
          drivers_options: item.rental_company.drivers
        }))
      }
      this.$modal.show('arrange-popup')
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    onClientsSearch(search, loading) {
      loading(true)
      this.searchClient(loading, search, this)
    },
    searchClient: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.clients_options = []
      } else {
        getClientsLite({search}).then(response => {
          vm.clients_options = response.data
          loading(false)
        })
      }
    }, 350),
    onEmployeeSearch(search, loading) {
      loading(true)
      this.searchEmployee(loading, search, this)
    },
    searchEmployee: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.employees_options = []
      } else {
        getEmployeesListSearch({ search, employment_status: 'working' }).then(response => {
          loading(false)
          vm.employees_options = response.data
        })
      }
    }, 350),
    onShowHotelArrivalPopup() {
      this.hotel_arrival_form = {
        points: [{ location: null }]
      }
      this.$v.hotel_arrival_form.$reset()
      this.$modal.show('hotel-arrival')
    },
    onShowHotelDeparturePopup() {
      this.hotel_departure_form = {
        points: [{ location: null }]
      }
      this.$v.hotel_departure_form.$reset()
      this.$modal.show('hotel-departure')
    },
    onShowHotelOtherPopup() {
      this.hotel_other_form = {
        points: [{ location: null }]
      }
      this.$v.hotel_other_form.$reset()
      this.$modal.show('hotel-other')
    },
  }
}
</script>

<style lang="sass" scoped>
.before-info
  margin-bottom: 15px
  padding: 10px 0
  border-top: 1px solid #e8e8e8
  border-bottom: 1px solid #e8e8e8

.before-info__title
  margin-bottom: 8px
  color: $color-error

.before-info__wrapper
  display: flex
  align-items: center
  gap: 18px

.before-info__row
  margin-bottom: 6px

  > span
    &:first-child
      margin-right: 6px
      color: #5f5f5f

    &:last-child
      font-weight: 500

    i
      margin: 0 8px
      font-style: normal

.before-info__points
  img
    margin: 0 10px

.transfer-list
  max-width: 1100px

.sticky-title
  position: sticky
  top: 0
  z-index: 20
  padding: 3px 0
  background-color: #fff
</style>
